// GA4 tracking functions
export const pageview = (path) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', { page_path: path });
  }
};

export const event = ({ action, category, label, value }) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value
    });
  }
}; 